<script setup>
  defineProps({
    itemId: {
      type: [String, Number, Array],
      required: true
    },
    hideActions: {
      type: Array,
      default: () => []
    }
  })

  defineEmits(['copy', 'move', 'delete'])
</script>

<template>
  <div class="jwx-floating-toolbar" style="position: sticky; bottom: var(--jwx-block-spacing);">
    <div class="jwx-floating-toolbar__content">
      <button
        v-if="!hideActions.includes('copy')"
        @click.prevent="$emit('copy', itemId)"
        type="button" 
        class="jwx-button jwx-button--pill jwx-button--small"
      >
        Copy
      </button>
      <button
        v-if="!hideActions.includes('move')"
        @click.prevent="$emit('move', itemId)"
        type="button" 
        class="jwx-button jwx-button--pill jwx-button--small"
      >
        Move
      </button>
      <button
        v-if="!hideActions.includes('delete')"
        @click.prevent="$emit('delete', itemId)"
        type="button" 
        class="jwx-button jwx-button--pill jwx-button--small"
      >
        Delete
      </button>
    </div>
  </div>
</template>
